export const LANGUAGES = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'el', name: 'Ελληνικά', flag: '🇬🇷' },
];

export const SUPPORTED_LANGUAGE_CODES = LANGUAGES.map(lang => lang.code);
